import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChange,
  ViewChild,
} from "@angular/core";
import { TreeNode } from "primeng/api";

@Component({
  selector: "ads-dropdowntreeView",
  templateUrl: "./dropdown-treeview.component.html",
  styleUrls: ["./dropdown-treeview.component.scss"],
})
export class DropdownTreeviewComponent {
  @Input("datasource") datasource: any[] = [];
  @Input("searchlimit") searchlimit: number = 2;

  @Input("selectedValue") selectedValue: any = {};
  @Output("selectedValueChange") selectedValueChange = new EventEmitter<any>();

  @Input("selectedValues") selectedValues: any[] = [];
  @Output("selectedValuesChange") selectedValuesChange = new EventEmitter<any[]>();

  @Input("isPrimitive") isPrimitiveBinding: boolean = true;
  @Input("isSingleSelection") isSingleSelection: boolean = true;
  @Input("disabled") isControlDisabled: boolean = false;
  @Input("isNodeDetailsRequired") isNodeDetailsRequired: boolean = true;
  @Input("class") class: string = "";
  @Output("onSelect") valueSelected = new EventEmitter<any>();
  @Input("width") width: string = '';
  @Input("height") height: string = '';
  @Input("unitType") unitType: string = '';
  @ViewChild("treeButton") treeviewwidth: ElementRef;
  public selectedvalArray: any[] = [];

  public ChildrenFeild: any = "children";
  public textfield: string = "label";
  public valueField: string = "key";
  public selectedTexts: any[] = [];
  public data: any[];
  public searchTerm = "";
  public show: boolean = false;
  public treeviewOverlay: number;
  public selection = {
    mode: "single",
  };
  public offSet: any = { top: 0, left: 0 };
  constructor(private _eref: ElementRef) { }

  public ngOnInit(): void {
    this.data = this.datasource;
    this.populateSelectedText();
  }
  ngAfterViewInit() {
    this.treeviewOverlay = this.treeviewwidth.nativeElement.offsetWidth;
  }
  calculateCoords(event) {
    var rect = event.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.treeviewOverlay = rect.width;
    this.offSet = { top: rect.top + scrollTop + 10, left: rect.left + scrollLeft };
  }
  populateSelectedText(): void {
    if (this.datasource.length === 0) return;
    if (this.isSingleSelection &&
      typeof this.selectedValue == "undefined" ||
      this.selectedValue == null ||
      this.selectedValue == ""
    )
      return;
    if (!this.isSingleSelection
      && this.selectedValues
      && this.selectedValues.length == 0)
      return;
    //single select logic
    let tempArray = [];
    if (this.isPrimitiveBinding && this.isSingleSelection) {
      this.datasource.forEach((dataItem) => {
        tempArray.push(
          this.searchTree(dataItem, this.selectedValue, this.valueField)
        );
      });
      this.selectedValue = { "key": this.selectedValue };
    }
    if (!this.isPrimitiveBinding && this.isSingleSelection) {
      this.datasource.forEach((dataItem) => {
        tempArray.push(
          this.searchTree(
            dataItem,
            this.selectedValue[this.valueField],
            this.valueField
          )
        );
      });
    }
    // multiselect logic
    if (this.isPrimitiveBinding && !this.isSingleSelection) {
      let selectedItems = [];
      this.selectedValues.forEach((selectedValue) => {
        this.datasource.forEach((dataItem) => {
          tempArray.push(
            this.searchTree(dataItem, selectedValue, this.valueField)
          );
        });
        selectedItems.push({ "key": selectedValue });
      })
      this.selectedvalArray = selectedItems;
    }
    if (!this.isPrimitiveBinding && !this.isSingleSelection) {
      this.selectedValues.forEach((selectedValue) => {
        this.datasource.forEach((dataItem) => {
          tempArray.push(
            this.searchTree(
              dataItem,
              selectedValue[this.valueField],
              this.valueField
            )
          );
        });
      })
      this.selectedvalArray = this.selectedValues;
    }

    this.selectedTexts = [];
    tempArray.map((item) => {
      if (item) {
        return this.selectedTexts.push(item[this.textfield]);
      }
    });
    // this.expandAll();
  }

  searchTree(item: any, valueToSearch: any, property: string) {
    if (item[property] == valueToSearch) {
      return item;
    } else if (item[this.ChildrenFeild] != null) {
      var i;
      var result = null;
      for (i = 0; result == null && i < item[this.ChildrenFeild].length; i++) {
        result = this.searchTree(
          item[this.ChildrenFeild][i],
          valueToSearch,
          property
        );
      }
      return result;
    }
    return null;
  }

  public handleSelection(event): void {
    event.dataItem = event.node;
    //single select logic
    if (this.isPrimitiveBinding && this.isSingleSelection) {
      this.show = !this.show;
      this.selectedTexts = [];
      this.selectedValue = event.dataItem[this.valueField];
      this.selectedValueChange.emit(this.selectedValue);
    }
    if (!this.isPrimitiveBinding && this.isSingleSelection) {
      this.selectedTexts = [];
      if (
        event.dataItem[this.ChildrenFeild] &&
        event.dataItem[this.ChildrenFeild].length > 0
      ) {
        let tempObj = Object.assign({}, event.dataItem);
        if (!this.isNodeDetailsRequired) {
          delete tempObj[this.ChildrenFeild];
        } else {
          let searchedParent = {};
          for (var item of this.datasource) {
            searchedParent = this.searchTree(
              item,
              event.dataItem[this.valueField],
              this.valueField
            );
            if (searchedParent != null) {
              tempObj[this.ChildrenFeild] =
                searchedParent[this.ChildrenFeild];
              break;
            }
          }
        }
        this.selectedValue = {
          [this.valueField]: tempObj[this.valueField],
          [this.textfield]: tempObj[this.textfield],
          [this.ChildrenFeild]: tempObj[this.ChildrenFeild],
        };
        this.selectedValueChange.emit(this.selectedValue);
      } else {
        this.selectedValue = {
          [this.valueField]: event.dataItem[this.valueField],
          [this.textfield]: event.dataItem[this.textfield],
        };
        this.selectedValueChange.emit(this.selectedValue);
      }
      this.show = !this.show;
    }
    //multiselect logic
    if (this.isPrimitiveBinding && !this.isSingleSelection) {
      this.selectedTexts = [];
      this.selectedValues = [];
      this.selectedvalArray.forEach(dataItem => {
        this.selectedValues.push(dataItem[this.valueField]);
      })
      this.selectedValuesChange.emit(this.selectedValues);
    }
    if (!this.isPrimitiveBinding && !this.isSingleSelection) {
      this.selectedTexts = [];
      this.selectedValues = [];
      this.selectedvalArray.forEach(dataItem => {
        if (
          dataItem[this.ChildrenFeild] &&
          dataItem[this.ChildrenFeild].length > 0
        ) {
          let tempObj = Object.assign({}, dataItem);
          if (!this.isNodeDetailsRequired) {
            delete tempObj[this.ChildrenFeild];
          } else {
            let searchedParent = {};
            for (var item of this.datasource) {
              searchedParent = this.searchTree(
                item,
                dataItem[this.valueField],
                this.valueField
              );
              if (searchedParent != null) {
                tempObj[this.ChildrenFeild] =
                  searchedParent[this.ChildrenFeild];
                break;
              }
            }
          }
          this.selectedValues.push({
            [this.valueField]: tempObj[this.valueField],
            [this.textfield]: tempObj[this.textfield],
            [this.ChildrenFeild]: tempObj[this.ChildrenFeild],
          });
        } else {
          this.selectedValues.push({
            [this.valueField]: dataItem[this.valueField],
            [this.textfield]: dataItem[this.textfield] ? dataItem[this.textfield] : null,
          });
        }
      })
      this.selectedValuesChange.emit(this.selectedValues);
    }
    this.valueSelected.emit(event.dataItem);
    this.populateSelectedText();
  }
  expandAll() {
    this.datasource.forEach(node => {
      this.expandRecursive(node, true);
    });
  }
  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }
  onClickedOutside(e: Event) {
    if (!this._eref.nativeElement.contains(e.target)) {
      this.show = false;
    } else {
      this.show = true;
    }
    if (this._eref.nativeElement.querySelector(".k-state-focused")) {
      this.show = true;
    }
  }
  ngOnChanges(changes: SimpleChange) {
    if (typeof changes["selectedValues"] !== "undefined") {
      var change = changes["selectedValues"];
      if (!change.firstChange && !this.isSingleSelection) {
        this.populateSelectedText();
      }
    }
    if (typeof changes["selectedValue"] !== "undefined") {
      var change = changes["selectedValue"];
      if (!change.firstChange && this.isSingleSelection) {
        this.populateSelectedText();
      }
    }
    if (typeof changes["datasource"] !== "undefined") {
      var change = changes["datasource"];
      if (!change.firstChange) {
        this.data = this.datasource;
        this.populateSelectedText();
      }
    }
  }
}
